// src/redux/reducers/vendorKycReducer.js

// Action types
const SET_KYC_FILE   = 'SET_KYC_FILE';
const CLEAR_KYC_FILE = 'CLEAR_KYC_FILE';

// Action creators
// payload: { dataUrl: string, filename: string }
export const setKycFile = (payload) => ({
  type: SET_KYC_FILE,
  payload,
});
export const clearKycFile = () => ({
  type: CLEAR_KYC_FILE,
});

const initialState = {
  file: null,
  // file will be { dataUrl: "...base64...", filename: "aadhar.pdf" } or null
};

export default function vendorKycReducer(state = initialState, action) {
  switch (action.type) {
    case SET_KYC_FILE:
      return { ...state, file: action.payload };
    case CLEAR_KYC_FILE:
      return { ...state, file: null };
    default:
      return state;
  }
}
